const getStatusLabel = status => status || 'All';

const formatFilterDate = dateStr => {
  if (!dateStr) return '';
  const date = new Date(`${dateStr}T00:00:00`);
  return date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
};

const getDownloadSummary = (status, fromDate, toDate) => ({
  statusLabel: getStatusLabel(status),
  fromDateLabel: formatFilterDate(fromDate),
  toDateLabel: formatFilterDate(toDate),
  dateRangeLabel: `${formatFilterDate(fromDate)} to ${formatFilterDate(toDate)}`,
});

export { formatFilterDate, getDownloadSummary, getStatusLabel };
